import script from "./MainOperacionalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOperacionalPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=563506c7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563506c7"]])

export default __exports__